import ReserveeModel from "../../models/ReserveeModel";

export default () => ({
    model: new ReserveeModel()
});
